// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_wf-8";
export var editMode = "_wf-3";
export var headerRow = "_wf-a";
export var headerTitle = "_wf-b";
export var product = "_wf-1";
export var productDetails = "_wf-5";
export var productDivider = "_wf-7";
export var productImage = "_wf-2";
export var productInfo = "_wf-4";
export var productTitle = "_wf-6";
export var strikethrough = "_wf-9";
export var upsellProductsCard = "_wf-0";